import React, { useState, useEffect } from "react";
import ProgressBar from "../global/ProgressBar";
import EstadoObra from "../common/EstadoObra";
import DateRange from "../global/DateRange";
import Responsable from "./Responsable";
import CheckBox from "../obra/CheckBox";
import "../../css/ItemDetail.css";

const ItemDetail = ({
  id,
  item,
  callback,
  proyecto,
  modifier,
  saveItem,
  itemLabel,
  avancePicker,
  progressBar,
}) => {
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    if (isNaN(item[id]) && item[id] && id) {
      setEditMode(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (item) => {
    setEditMode(false);
    const { idProyecto } = proyecto;
    if (typeof saveItem === "function") {
      setEditMode(false);
      saveItem(idProyecto, item, callback);
    }
  };

  const getProgress = () => {
    let { progreso } = item;
    if (item.real) {
      progreso = item.real;
    }
    return parseFloat(progreso) * 100;
  };

  const getDifference = () => {
    return parseFloat(item.programado) - parseFloat(item.real);
  };

  const renderDates = () => {
    if (item.fecha_inicio && item.fecha_fin) {
      const difference = getDifference();
      // On time/ahead when real has caught up to programado (same signal as the
      // diferencial's EstadoObra). Treat unknown (NaN) as on time.
      const onTime = isNaN(difference) || difference <= 0;
      return (
        <DateRange
          start_label="FECHA INICIO"
          end_label="FECHA FIN"
          start_date={item.fecha_inicio}
          end_date={item.fecha_fin}
          onTime={onTime}
        />
      );
    }
  };

  const renderCritical = () => {
    if (item.punto_critico || item.puntoCritico) {
      return (
        <div className="mb-3">
          <CheckBox checked={true} />
          <span className="titleInputPlantilla">PUNTO CRITICO</span>
        </div>
      );
    }
  };

  const renderDiferencial = () => {
    const difference = getDifference();
    if (!isNaN(difference)) {
      if (difference !== 0) {
        return (
          <div className="row align-items-middle mb-3 px-1">
            <div className="col-6">
              <span className="bold">{parseFloat(parseFloat(difference) * 100).toFixed(2)}%</span>{" "}
              diferencial
            </div>
            <div className="col-6">
              <EstadoObra estado={difference <= 0 ? 1 : 2} />
            </div>
          </div>
        );
      }
    }
  };

  const renderButton = () => {
    if (proyecto.permiso === "coordinador") {
      if (editMode) {
        return (
          <div className="d-flex">
            <button className="btn btn-primary" onClick={handleSubmit}>
              <i className="fa fa-save"></i>
            </button>
            <button className="btn text-muted">
              <i className="fa fa-plus-square"></i>
            </button>
            <button className="btn text-muted">
              <i className="fa fa-trash"></i>
            </button>
          </div>
        );
      }
      return (
        <div className="d-flex">
          <button className="btn text-muted" onClick={() => setEditMode(true)}>
            <i className="fa fa-edit"></i>
          </button>
          <button className="btn text-muted">
            <i className="fa fa-plus-square"></i>
          </button>
          <button className="btn text-muted">
            <i className="fa fa-trash"></i>
          </button>
        </div>
      );
    }
  };

  const renderPonderacion = () => {
    let ponderacion = parseFloat(item.ponderacion);
    if (ponderacion < 1) {
      ponderacion = ponderacion * 100;
    }
    return (
      <p className="mt-2 mb-1" style={{ fontSize: 13 }}>
        <span className="fw-semibold">
          {isNaN(ponderacion) ? "-" : `${ponderacion}%`}
        </span>{" "}
        <span className="text-muted">ponderación</span>
      </p>
    );
  };
  const progreso = getProgress();

  return (
    <div className="container-fluid px-0 position-relative">
      <div className="row mx-0 mb-2 align-items-center">
        <div className="col-10 px-0">
          {editMode ? (
            <>
              <p className="text-muted mb-1" style={{ fontSize: 11, letterSpacing: 0.5 }}>DETALLE</p>
              <input
                type="text"
                className="form-control form-control-sm"
                value={item.nombre}
                onChange={(e) => modifier("nombre", e.target.value)}
              />
            </>
          ) : (
            <>
              <p className="text-muted mb-1" style={{ fontSize: 11, letterSpacing: 0.5 }}>DETALLE</p>
              <p className="text-uppercase mb-0" style={{ fontSize: 14, lineHeight: 1.4 }}>{item.nombre}</p>
            </>
          )}
        </div>
      </div>
      <div className="col-12">{renderButton()}</div>
      <div className="mb-3">
        {renderPonderacion()}
        {progressBar ? progressBar : <ProgressBar progress={progreso} />}
        {avancePicker && <div className="mt-2">{avancePicker}</div>}
      </div>
      {renderCritical()}
      {renderDiferencial()}
      {renderDates()}
      <div className="row mx-0 mt-3">
        <Responsable
          item={item}
          modifier={modifier}
          itemLabel={itemLabel}
          handleSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};

export default ItemDetail;
